import { render, staticRenderFns } from "./comp_CheckoutCollapsedSummary.vue?vue&type=template&id=1db0b52e&scoped=true&"
import script from "./comp_CheckoutCollapsedSummary.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutCollapsedSummary.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutCollapsedSummary.vue?vue&type=style&index=0&id=1db0b52e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0b52e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
